import Cookies from 'js-cookie';
import { Component } from 'react';
import { connect } from 'react-redux';

import {
  CheckoutLayout,
  Title,
  SecurityStatement,
  CheckoutInner
} from 'common/components/layout';
import Questions from 'profile/login/Questions';
import { getCustomer } from 'redux/customer/actions';

import ContinueAsGuest from './components/ContinueAsGuest';
import ReturningCustomerForgot from './components/ReturningCustomerForgot';

class ForgotPassword extends Component {
  componentDidMount() {
    const { props } = this;
    if (Cookies.get('customerToken')) {
      props.getCustomer();
    }
  }

  render() {
    const { settings } = this.props;
    if (!settings.data) {
      return (
        <CheckoutLayout title="Forgot Password" loading showSideCart={false}>
          <CheckoutInner>
            <Title>Forgot Password</Title>
          </CheckoutInner>
        </CheckoutLayout>
      );
    }
    return (
      <CheckoutLayout title="Forgot Password" showSideCart={false}>
        <CheckoutInner settings={settings}>
          <Title>Forgot Password</Title>
          <div className="c7-account-login">
            <ReturningCustomerForgot />
            <ContinueAsGuest settings={settings} />
          </div>
          <SecurityStatement settings={settings} />
          <Questions settings={settings} />
        </CheckoutInner>
      </CheckoutLayout>
    );
  }
}

const mapStateToProps = (state) => ({
  customer: state.customer,
  settings: state.setting
});

export default connect(mapStateToProps, { getCustomer })(ForgotPassword);
